export interface SingleFlightRefresh {
  request(): void;
  cancelPending(): void;
  isInFlight(): boolean;
  hasPending(): boolean;
}

/**
 * Collapse a burst into one current run plus at most one trailing run. Requests
 * made while the surface is disallowed (normally hidden) stay pending until a
 * later request after resume.
 */
export function createSingleFlightRefresh(
  run: () => Promise<void>,
  isAllowed: () => boolean,
  onError: (error: unknown) => void = () => undefined
): SingleFlightRefresh {
  let inFlight = false;
  let pending = false;

  const drain = () => {
    if (inFlight || !pending || !isAllowed()) return;
    pending = false;
    inFlight = true;
    let task: Promise<void>;
    try {
      task = run();
    } catch (error) {
      task = Promise.reject(error);
    }
    void task
      .catch(onError)
      .finally(() => {
        inFlight = false;
        drain();
      });
  };

  return {
    request() {
      pending = true;
      drain();
    },
    cancelPending() {
      pending = false;
    },
    isInFlight: () => inFlight,
    hasPending: () => pending,
  };
}
